var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.openChoose}},[_vm._t("default")],2),_vm._v(" "),_c('input',{ref:"fileInputRef",staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.accept,"name":"上传"},on:{"change":_vm.fileChoosed}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7dd0b3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operateManage/wechat_push/fileUpload.vue
// module id = null
// module chunks = 